// extracted by mini-css-extract-plugin
module.exports = {"moreBtn":"moreBtn___2gOfd","icon":"icon___zrXG6"};